import React, { useState, useEffect } from "react";
import Select from "react-select";

const style = {
  control: (base, state) => ({
    ...base,
    alignItems: "center",
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000811",
    whiteSpace: "nowrap",
  }),
  valueContainer: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    minHeight: "33px",
    height: "33px",
    padding: "0 10px",
    overflow: "hidden",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    lineHeight: "1.2",
  }),
  singleValue: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    height: "100%",
    margin: 0,
    maxWidth: "100%",
    position: "static",
    top: "auto",
    transform: "none",
    lineHeight: "1.2",
  }),
  placeholder: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    height: "100%",
    margin: 0,
    position: "static",
    top: "auto",
    transform: "none",
    lineHeight: "1.2",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    alignItems: "center",
    height: "33px",
  }),
  clearIndicator: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    height: "33px",
    justifyContent: "center",
    padding: 0,
    width: "32px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    alignItems: "center",
    display: "flex",
    height: "33px",
    justifyContent: "center",
    padding: 0,
    width: "32px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    alignSelf: "center",
    height: "20px",
    marginBottom: 0,
    marginTop: 0,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 100000,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 100000,
  }),
};

export const DropDownComponent = ({
  isDisabled,
  placeHolder,
  pageName,
  dpDownName,
  stateData,
  controlName,
  handleChange,
  value,
  valueId,
  setState,
  checkLabel,
  components,
  refComp,
  inputId,
  menuPortalTarget,
  customStyles,
  hideSelectedOptions
}) => {
  const [dropdownOption, setDropdownOption] = useState([]);
  const resolvedMenuPortalTarget =
    menuPortalTarget !== undefined
      ? menuPortalTarget
      : typeof document !== "undefined"
        ? document.body
        : null;
  useEffect(() => {
    const GetData = () => {
      if (stateData) {
        let list = FormatdrpOption(stateData);
        setDropdownOption(list);
      }
    };
    GetData();
  }, [stateData]);

  useEffect(() => {
    if (!dropdownOption?.length) {
      if (!valueId) {
        setState(null);
      }
      return;
    }

    let selectedValue = null;

    if (checkLabel) {
      selectedValue = dropdownOption.find(
        (item) => String(item.label) === String(valueId)
      );
    } else {
      selectedValue = dropdownOption.find(
        (item) => String(item.value) === String(valueId)
      );
    }

      if (typeof setState === "function") {
      setState(selectedValue);
    }
  }, [dropdownOption, valueId, checkLabel, setState]);

  const FormatdrpOption = (list) => {
    var te = list?.map((data, index) => ({
      ...data,
      label: GetLabel(data),
      value: GetId(data),
    }));
    return te;
  };
  const GetLabel = (data) => {

    if (dpDownName === "designation") return data?.designationName;
    else if (dpDownName === "department") return data?.departmentName;
    else if (["designConsultantData", "orderType"].includes(dpDownName)) return data?.label;
    else if (dpDownName === "assignedTo" || dpDownName === "salesengineer" || dpDownName === "allocatedTo")
      return (
        data?.fullName ||
        data?.engineerName ||
        data?.employeeName ||
        data?.name ||
        data?.label ||
        `${data?.firstName ?? ""} ${data?.lastName ?? ""}`.trim()
      );
    else if (dpDownName === "projectsegment") return data?.segmentName;
    else if (dpDownName === "projectstatus") return data?.statusName;
    else if (dpDownName === "customer") return data?.customerName;
    else if (dpDownName === "orderRef") return data?.customerOrderReference || data?.orderReference;
    else if (dpDownName === "quoteRef") return data?.quoteReference;
    else if (dpDownName === "distributor") return data?.distributorName;
    else if (dpDownName === "mainContractor") return data?.customerName;
    else if (dpDownName === "mepContractor") return data?.customerName;
    else if (dpDownName === "client") return data?.customerName;
    else if (dpDownName === "superVision") return data?.customerName;
    else if (dpDownName === "country") return data?.name;
    else if (dpDownName === "status" || dpDownName === "quotevalidity" || dpDownName === "projectreference")
      return data?.label;
    else if (dpDownName === "project") return data?.projectName;
    else if (dpDownName === "paymentterms") return data?.paymentDescription;
    else if (dpDownName === "deliveryterms") return data?.deliveryDescription;
    else if (dpDownName === "transportmode") return data?.transportationMode;
    else if (dpDownName === "enquiry") return data?.inquiryRef;
    else if (dpDownName === "currency") return data?.currencyName;
    else if (dpDownName === "currencyCode") return data?.shortCode;
    else if (dpDownName === "company") return data?.companyName;
    else if (dpDownName === "customerStatus") return data?.status;
    else if (dpDownName === "inquiryTypesdrp") return data?.type;
    else if (dpDownName === "distributorTypesdrp") return data?.typeName;
    else if (dpDownName === "lostreason") return data?.quoteLostReason;
    else if (dpDownName === "quotestatus") return data?.statusDesc;
    else if (dpDownName === "role") return data?.name
    else if (dpDownName === "productGroup") return data?.group
    else if (dpDownName === "productFamily") return data?.family
    else if (dpDownName === "quotationId") return data?.quotationReference
    else return "";
  };
const GetId = (data) => {
  if (
    dpDownName === "allocatedTo" ||
    dpDownName === "assignedTo" ||
    dpDownName === "salesengineer"
  )
    return data?.identityId;

  else if (
    ["status", "orderType", "quotevalidity", "projectreference"].includes(dpDownName)
  )
    return data?.value;

  else if (dpDownName === "quotationId")
    return data?.quotationId;

  else if (dpDownName === "orderRef")
    return data?.customerOrderId || data?.id;

  else
    return data?.id;
};

  return (
    <Select
      name={controlName}
      inputId={inputId}
      options={dropdownOption}
      className="basic-multi-select"
      classNamePrefix="react-select"
      onChange={handleChange}
      value={value}
      styles={{ ...style, ...customStyles }}
      placeholder={placeHolder}
      hideSelectedOptions={hideSelectedOptions}
      menuPortalTarget={resolvedMenuPortalTarget}
      menuPosition={resolvedMenuPortalTarget ? "fixed" : "absolute"}
      theme={(theme) => ({
        ...theme,
        colors: { ...theme.colors, neutral80: "#000000" },
      })}
      isDisabled={isDisabled}
      isClearable={!["customerStatus", "role"].includes(dpDownName)}
      components={components}
      ref={refComp}
    />
  );
};
